module.exports = __webpack_public_path__ + "files/2e40cd7bc533912184c24fc245122ce9.png";